import { toast } from "sonner";
import { Copy, ExternalLink } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { LabelBadge } from "@/components/admin/LeadTable";

const Row = ({ k, v }) => (
  <div className="py-2.5 border-b border-parchment-200 grid grid-cols-[130px_1fr] gap-3 text-sm">
    <span className="text-[#8A978E]">{k}</span><span className="text-forest-800">{v || "—"}</span>
  </div>
);

export default function LeadDetail({ lead, onClose }) {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(lead.whatsapp_message);
      toast.success("WhatsApp message copied");
    } catch {
      toast.error("Could not copy. Please select the text and copy manually.");
    }
  };
  const waLink = lead?.phone ? `https://wa.me/91${lead.phone.replace(/\D/g, "").slice(-10)}?text=${encodeURIComponent(lead.whatsapp_message)}` : null;

  return (
    <Sheet open={!!lead} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="bg-parchment w-full sm:max-w-lg overflow-y-auto" data-testid="lead-detail-sheet">
        {lead && (
          <>
            <SheetHeader>
              <div className="flex items-center gap-3"><LabelBadge label={lead.label} /></div>
              <SheetTitle className="font-serif text-3xl text-forest-800 text-left" data-testid="lead-detail-name">{lead.name || "Unknown visitor"}</SheetTitle>
            </SheetHeader>
            <div className="mt-6">
              <p className="eyebrow mb-2">Summary</p>
              <p className="text-sm leading-relaxed text-forest-900 bg-white border border-parchment-300 rounded-xl p-4" data-testid="lead-detail-summary">{lead.summary}</p>
            </div>
            <div className="mt-6">
              <Row k="Phone" v={lead.phone} />
              <Row k="Current course" v={lead.current_course} />
              <Row k="Interested in" v={lead.interested_course} />
              <Row k="Consultation for" v={lead.consultation_for} />
            </div>
            <div className="mt-8">
              <p className="eyebrow mb-2">WhatsApp follow-up</p>
              <textarea readOnly value={lead.whatsapp_message} rows={7} className="w-full text-sm bg-[#E7F6EC] border border-[#25D366]/30 rounded-xl p-4 text-forest-900 resize-none" data-testid="lead-detail-whatsapp-text" />
              <div className="mt-3 flex flex-col sm:flex-row gap-2">
                <button onClick={copy} className="flex-1 flex items-center justify-center gap-2 bg-forest-800 text-parchment font-semibold py-3 rounded-full hover:bg-forest-700" data-testid="lead-copy-whatsapp-button">
                  <Copy className="w-4 h-4" /> Copy message
                </button>
                {waLink && (
                  <a href={waLink} target="_blank" rel="noopener noreferrer" className="flex-1 flex items-center justify-center gap-2 bg-[#25D366] text-forest-900 font-semibold py-3 rounded-full hover:brightness-105" data-testid="lead-open-whatsapp-link">
                    <ExternalLink className="w-4 h-4" /> Open WhatsApp
                  </a>
                )}
              </div>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
